export default {
    case_severity_1: 'Asymptomatic',
    case_severity_2: 'Moderate',
    case_severity_3: 'Severe',
};
